export enum AdminProductStatus {
  Draft = 'DRAFT',
  Private = 'PRIVATE',
  Protected = 'PROTECTED',
  Public = 'PUBLIC',
}
